export default {
  TYPES: [
    { KEY: 'EMPLOYEE', VALUE: 'Motorista' },
    { KEY: 'TERMINAL', VALUE: 'Rede de Venda' },
  ],
};
